@if (device?.media?.url || device?.media?.urlTwicPic) {
  <sd-banner [isFit]="true" [imgRatio]="imageRatioEnum.r1_1" [media]="device?.media" />
}

@if (device?.link?.url) {
  <sd-link
    [link]="device?.link"
    (clicked)="onClickedDevice()"
    customClass="c__link is-reset is-full-area"
  >
    <ng-container *ngTemplateOutlet="deviceLinkInformation" />
  </sd-link>
} @else if (device?.label) {
  <span class="c__link">{{ device.label }}</span>
}

<ng-template #deviceLinkInformation>
  <span class="c__container">
    <span class="is-caption is-semi-bold">
      {{ device?.link?.linkName }}
    </span>
    <span class="c__icon">
      <sd-icon name="icon-arrow-right" [brand]="brand" [size]="iconSize.small" />
    </span>
  </span>
</ng-template>
